import script from "./cooperatePop.vue?vue&type=script&setup=true&lang=js"
export * from "./cooperatePop.vue?vue&type=script&setup=true&lang=js"

import "./cooperatePop.vue?vue&type=style&index=0&id=5e402af8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e402af8"]])

export default __exports__